import React from 'react';
import PageLayout from '../components/PageLayout';

const ContactUs = () => (
  <PageLayout title="Contact Us">
    <p>We'd love to hear from you! Whether you have a question, feedback, or need help with an order, our team is here to assist.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Get in Touch</h2>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, marginTop: 16 }}>
      <div style={{ background: '#F5E6C8', borderRadius: 12, padding: 20, textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>📧</div>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#2D1A00' }}>Email</h3>
        <p style={{ fontSize: 13, color: '#6B6B6B' }}>support@chaknapoint.com</p>
      </div>
      <div style={{ background: '#F5E6C8', borderRadius: 12, padding: 20, textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>📞</div>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#2D1A00' }}>Phone</h3>
        <p style={{ fontSize: 13, color: '#6B6B6B' }}>+91 98765 43210</p>
      </div>
      <div style={{ background: '#F5E6C8', borderRadius: 12, padding: 20, textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>⏰</div>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#2D1A00' }}>Hours</h3>
        <p style={{ fontSize: 13, color: '#6B6B6B' }}>Mon-Sun: 10AM - 11PM</p>
      </div>
    </div>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8, color: '#2D1A00' }}>Office Address</h2>
    <p>Chakna Point<br />Delhi, India<br />PIN: 110001</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Response Time</h2>
    <p>We typically respond within 24 hours. For urgent order-related issues, please call us directly.</p>
  </PageLayout>
);

export default ContactUs;
